import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Pages/Home';
import Rules from './components/Pages/Rules';
import Contact from './components/Pages/Contact';
import './App.css';
import Registration from './components/Pages/Registration';
import About from './components/Pages/About';
import RaceDay from './components/Pages/RaceDay';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NavigationBar = () => (
  <Navbar bg="light" expand="md" className="mb-4">
    <Container>
      <Navbar.Brand as={Link} to="/">Osseo Lutefiskman</Navbar.Brand>
      <Navbar.Toggle aria-controls="main-navbar-nav" />
      <Navbar.Collapse id="main-navbar-nav">
        <Nav className="ms-auto">
          <Nav.Link as={Link} to="/">Home</Nav.Link>
          <Nav.Link as={Link} to="/about">About</Nav.Link>
          <Nav.Link as={Link} to="/raceday">Race Day</Nav.Link>
          <Nav.Link as={Link} to="/rules">Rules</Nav.Link>
          <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

const App: React.FC = () => {
  return (
    <Router>
      <NavigationBar />
      <main style={{ padding: '2rem' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/about" element={<About />} />
              <Route path="/raceday" element={<RaceDay />} />
              {/* Additional routes will be added here */}
            </Routes>
          </main>
        
    </Router>
  );
};

export default App;
